import script from "./AnnouncementsManagingPageTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsManagingPageTitle.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsManagingPageTitle.vue?vue&type=style&index=0&id=61fa3840&lang=scss&scoped=true"
script.__scopeId = "data-v-61fa3840"

export default script